import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

interface PaymentProps extends React.SVGProps<SVGSVGElement> {
  outline?: boolean;
}

export const Payment: React.FC<PaymentProps> = ({ outline = false, ...props }) => {
  if (outline) {
    return <PaymentOutline {...props} />;
  }

  return (
    <SVG width='24' height='24' viewBox='0 0 24 24' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2Zm0 8H4V8h16v4Zm-2 3h-5v2h5v-2Z'
      />
    </SVG>
  );
};

export const PaymentOutline: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <SVG width='24' height='24' viewBox='0 0 24 24' {...props}>
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 4h16c1.11 0 2 .89 2 2v12c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-12c0-1.11.88-2 1.99-2Zm0 14h16v-6H4v6ZM20 8H4V6h16v2Zm-2 6h-5v2h5v-2Z'
    />
  </SVG>
);
